<template>
    <header class="flex justify-center bg-white">
        <nav class="flex max-w-7xl flex-1 flex-col justify-center p-6 lg:px-8" aria-label="Global">
            <div class="flex items-center justify-between">
                <!-- logo -->
                <Link :href="route('home')" class="-m-1.5 p-1.5">
                    <span class="sr-only">Leben-ohne-Grenzen</span>
                    <!-- insert logo -->
                    <!-- <img class="h-8 w-auto" src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600" alt="" /> -->
                    <ApplicationLogo class="h-12" />
                </Link>

                <!-- call number -->
                <div class="hidden lg:block">
                    <!-- <p class="text-sky-500 font-semibold text-end">Kostenlose Beratung</p> -->
                    <div class="flex items-center gap-2">
                        <PhoneIcon class="text-sky-700" />
                        <a href="tel:+49 221 82829650" class="font-bold text-sky-950 lg:text-2xl"> +49 221 82829650 </a>
                    </div>
                    <p class="text-end text-sm">Mo.- Fr. 8 bis 20 Uhr</p>
                </div>

                <div class="flex lg:hidden">
                    <button
                        type="button"
                        class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        @click="setOpen(true)"
                    >
                        <span class="sr-only">Open main menu</span>
                        <Bars3Icon class="h-7 w-7" aria-hidden="true" />
                    </button>
                </div>
            </div>

            <div class="mt-2 hidden justify-center gap-x-16 lg:flex lg:flex-row">
                <Link
                    v-for="item in navigation"
                    :key="item.name"
                    :href="item.href"
                    class="text-sm font-semibold leading-6 text-gray-900"
                    >{{ item.name }}</Link
                >
            </div>
            <hr class="mt-6 hidden lg:block" />
            <!-- menu -->
        </nav>

        <!-- mobile only -->
        <MobileDialog :navItems="mobileNav" :show="isOpen" @setOpen="setOpen" />
    </header>
</template>

<script setup>
import { ref } from 'vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import PhoneIcon from '@/Components/SVG/Phone.vue'
import ApplicationLogo from '@/Components/ApplicationLogo.vue'
import MobileDialog from '@/Components/AppLayout/MobileDialog.vue'
import { Link } from '@inertiajs/vue3'

const isOpen = ref(false)

function setOpen(value) {
    isOpen.value = value
}

const navigation = [
    { name: 'Startseite', href: route('home') },
    { name: 'Treppenlifts', href: route('stairlift.index') },
    { name: 'E-Rollstühle', href: route('wheelchair.index') },
    { name: 'Ratgeber', href: route('blog.index') },
    // { name: "Log In", href: "#" },
]
const mobileNav = [
    { name: 'Startseite', href: route('home') },
    { name: 'Treppenlifts', href: route('stairlift.index') },
    { name: 'E-Rollstühle', href: route('wheelchair.index') },
    { name: 'Ratgeber', href: route('blog.index') },
    { name: 'Log In', href: route('dashboard') },
]
</script>
